module.exports = __webpack_public_path__ + "static/media/question-mark.e064c97d.svg";